"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDashboardPlaceholderWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
exports.LoadingDashboardPlaceholderWidget = function () {
    return (react_1.default.createElement("div", { className: classnames_1.default("drag-info-placeholder", "dash-item", "type-loading") },
        react_1.default.createElement(sdk_ui_kit_1.LoadingDots, null)));
};
//# sourceMappingURL=LoadingDashboardWidget.js.map